module.exports = __webpack_public_path__ + "static/media/9.df670b68.jpg";